import EnhancedForm from '@runway/enhanced-form';
import debounce from '@runway/util-debounce';
import { validateEmailAddress } from "../../utils/member-enrollment";
import { hide, show } from "@runway/util-dom";

export const name = 'corporate-member-enrollment';

export default class CorporateMemberEnrollment extends EnhancedForm {
    get name() {
        return name;
    }

    constructor(node) {
        super(node);

        this.emailSelector = '#subscription_details_form_email';
        this.existingMemberChoiceSelector = '[name*="details_form[existingMember]"]';
        this.emailInfoNotification = this.node.querySelector('.rw-notification-message--email-info');
        this.emailErrorNotification = this.node.querySelector('.rw-notification-message--email-error');

        this.addEventListeners();
    }

    addEventListeners() {
        const debouncedValidateEmail = debounce(event => this.validateEmail(event), 0);
        const existingMemberChoiceNodes = Array.from(this.node.querySelectorAll(this.existingMemberChoiceSelector));

        this.subscribe(`dom:${this.emailSelector}:blur`, debouncedValidateEmail);

        existingMemberChoiceNodes.forEach(node => {
            this.subscribe(`dom:#${node.getAttribute('id')}:change`, event => this.onExistingMemberChoiceChange(event));
        });
    }

    onExistingMemberChoiceChange({ target }) {
        const relativeUrl = target.getAttribute('data-url');

        if (relativeUrl) {
            window.location.href = new URL(relativeUrl, window.location.origin);
        }
    }

    async validateEmail(event) {
        event.stopPropagation();

        const emailAddress = event.target.value;

        if (emailAddress) {
            try {
                await validateEmailAddress(emailAddress);

                hide(this.emailInfoNotification);
                show(this.emailErrorNotification);
            } catch (error) {
                show(this.emailInfoNotification);
                hide(this.emailErrorNotification);
            }
        }
    }
}
